export const ROOT = '/template';
export const MODULE = 'TEMPLATE';
